import { callWithCache } from '../utils/callWithCache';

export const pagesService = {
  loadPage: async (pageKey, language) => await callWithCache(window.cet.microservices.nairobiapi.pages.getPage, 'pages', { pageKey, language })
};
